module.exports = __webpack_public_path__ + "static/mopz-hero@2x-min-330a826652b4430a344e14fdfba8b50b.png";